window.$ = window.jQuery = require('jquery');

import AOS from './aos.js';

$(document).ready(function () {

    // fadeIn
    AOS.init({
        duration: 1200,
    });

    // fix header
    let headerHeightSet = false;
    let headerHeight;

    $(window).on('scroll', function(){
        let header = $('.header'),
            scroll = $(window).scrollTop();

        if (!headerHeightSet) {
            headerHeight = header.outerHeight(true);
            headerHeightSet = true;
        }
        
        if (scroll >= headerHeight) {
            header.addClass('fixed');
        } else {
            header.removeClass('fixed');
        }
    });
    
    // burger menu
    function openMenu(){
        $('body').css({'overflow': 'hidden'});
        $('.js-burger-open').addClass('opened');
        $('.header').addClass('opened');
    }

    function closeMenu(){
        $('body').css({'overflow': ''});
        $('.js-burger-open').removeClass('opened');
        $('.header').removeClass('opened');
    }

    $('.js-burger-open').on('click', function(){
        if($('.header').hasClass('opened')){    
            closeMenu();
        } else {
            openMenu();
        }

        return false;
    });

    $(window).on('resize', function(){
        if ($(window).width() > 766) {
            closeMenu();
        }
    });

    // scroll to element
    if (window.location.hash) {
        setTimeout(function(){
            scrollToSection(window.location.hash);
        }, 50);
    }

    $('a[href*="#"]').on('click', function (e) {
        e.preventDefault();
        if (this.hash.length>0) {
            if (this.pathname === window.location.pathname) {
                scrollToSection(this.hash);
            }
            else {
                window.location.replace(this.href);
            }
        }
    });

    function scrollToSection(id) {
        let $header = $('header');

        if($header.hasClass('opened')){
            closeMenu();
        }

        if($(window).innerWidth() < 992){
            closeMenu();
            $('html, body').animate({
                scrollTop: $(id).offset().top-48
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $(id).offset().top-48
            }, 1000);
        }
    }

    // accordion
    $('.js-accordQuest').on('click', function(){
        $(this).toggleClass('opened');
        $(this).closest('.js-accordParent').find('.js-accordAnsw').slideToggle();
    });

    // Source form
    $('.js-formSourceButton').on('click', function(){
        let source = $(this).data('source');

        $('.js-formSource').val(source).change();
    });

});